import React from "react";
import Radium from "radium";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";

const styles = {
	customlabel: {
		fontSize: "0.8em",
		marginTop: 5,
		marginLeft: 2,
	},
	crossRequired: {
		color: "#c5190e",
		fontSize: "1em",
		position: "relative",
		bottom: 1,
		left: 3,
	},
};
const errorStyle = {
	marginBottom: 10,
	color: "#dc0000",
	fontSize: "0.7em",
};

const selectCustomErrorStyles = {
	container: (provided) => ({
		...provided,
		cursor: "pointer",
	}),
	option: (provided) => ({
		...provided,
		color: "#9f3a38",
		cursor: "pointer",
	}),
	control: (provided) => ({
		...provided,
		background: "#fff6f6",
		borderColor: "#e0b4b4",
		color: "#9f3a38",
		cursor: "pointer",
	}),
};

const selectCustomStyles = {
	container: (provided) => ({
		...provided,
		cursor: "pointer",
	}),
	option: (provided) => ({
		...provided,
		cursor: "pointer",
	}),
	control: (provided) => ({
		...provided,
		cursor: "pointer",
	}),
};

// Used to disable google autoComplete
const Input = ({ autoComplete, ...props }) => {
	return <components.Input {...props} autoComplete="off" />;
};

const CustomSelect = ({
	field: { name, value, onBlur, onChange },
	form: { errors, touched, setFieldValue },
	id,
	label,
	className,
	options,
	menuPlacement,
	placeholder,
	isMulti = false,
	isCreatable = false,
	defaultValue,
	style = {},
	testRef,
	disabled,
	...props
}) => {
	id = id ?? name;

	const getValue = () => {
		if (isMulti) return value;
		else if (isCreatable && value)
			return (
				options.find((op) => op.value === value) || {
					value: value,
					label: value,
				}
			);
		else return options.find((op) => op.value === value) || null;
	};

	return (
		<div>
			<div style={styles.customlabel}>
				{props.customlabel}
				{props.required && <span style={styles.crossRequired}>*</span>}
			</div>

			{!isCreatable && (
				<Select
					name={name}
					inputId={String(id)}
					value={getValue()}
					onChange={(option) => {
						if (isMulti) setFieldValue(name, option);
						else setFieldValue(name, option.value);
						console.log("Select onChange", onChange, option);
						if (onChange) onChange(option);
					}}
					onBlur={onBlur}
					placeholder={placeholder || "Sélectionner une valeur dans la liste"}
					styles={touched[id] && errors[name] ? selectCustomErrorStyles : selectCustomStyles}
					isMulti={isMulti}
					options={options}
					components={{
						Input,
					}}
					style={style}
					className={className}
					ref={props.innerref}
					isDisabled={disabled}
					noOptionsMessage={() => "Aucun résultat"}
					loadingMessage={() => "Chargement..."}
					menuPlacement={menuPlacement}
				/>
			)}
			{isCreatable && (
				<CreatableSelect
					name={name}
					inputId={String(id)}
					value={getValue()}
					onChange={(option) => {
						if (isMulti) setFieldValue(name, option);
						else setFieldValue(name, option.value);
					}}
					onBlur={onBlur}
					placeholder={placeholder || "Sélectionner une valeur ou taper votre réponse"}
					styles={touched[id] && errors[name] ? selectCustomErrorStyles : selectCustomStyles}
					isMulti={isMulti}
					options={options}
					components={{
						Input,
					}}
					style={style}
					className={className}
					ref={props.innerref}
					isDisabled={disabled}
					formatCreateLabel={(inputValue) => `Créer "${inputValue}"`}
					noOptionsMessage={() => "Aucun résultat"}
					loadingMessage={() => "Chargement..."}
					menuPlacement={menuPlacement}
				/>
			)}

			{touched[id] && errors[name] && <div style={errorStyle}>{errors[name]}</div>}
		</div>
	);
};

export default Radium(CustomSelect);
